import * as React from "react";
import PropTypes from "prop-types";
const SvgActivityElevationNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.244 4.13c.758-1.39 2.754-1.39 3.512 0l3.335 6.115 1.153-2.115c.758-1.39 2.754-1.39 3.512 0l4.927 9.034A2.593 2.593 0 0120.406 21H4a3 3 0 01-3-3v-3.49a3 3 0 01.366-1.437zM8 5.088L3.122 14.03A1 1 0 003 14.51V18a1 1 0 001 1h16.406a.594.594 0 00.521-.878L16 9.088l-2.91 5.333z"
        fill=""
      />
    </svg>
  )
);
SvgActivityElevationNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActivityElevationNormalSmall;
